<script setup>
import { ref, defineEmits } from 'vue'
import axios from "axios";

const searchText = ref(null)
const response = ref(null)

const emit = defineEmits(['selectField'])

function searchAddress() {
  getGEOLocation(searchText.value);
}

function getGEOLocation(ip) {
  axios
  // .post(
  //   "https://cors-anywhere.herokuapp.com/https://api.ip2location.io/?"
  //     + "key=" + process.env.VUE_APP_IP2LOCATION_KEY
  //     + "&ip=" + ip
  //     + "&format=json",
  //     {
  //       headers: {
  //         'Access-Control-Allow-Origin': '*',
  //         'Content-type': 'application/json',
  //       }
  //     }
  // )
  .get(
    "http://ip-api.com/json/"
      + ip
  )
  // .get(
  //   "http://api.ipapi.com/api/"
  //     + ip
  //     + "?access_key=" + process.env.VUE_APP_IPAPI_KEY
  // )
  .then((res) => {
    console.log(res);

    response.value = res
    emit('selectField', {
      // lat: response.value.data.latitude,
      // lng: response.value.data.longitude,
      lat: response.value.data.lat,
      lng: response.value.data.lon,
    });
  })
  .catch((error) => {
    console.error("APIリクエストエラー:", error);
  });
}
</script>

<template>
  <form class="d-flex mb-1" role="search" @submit.prevent="searchAddress()">
    <input class="form-control me-1" type="search" placeholder="Search IP Address" aria-label="Search" v-model="searchText">
    <button class="btn btn-sm btn-dark" type="submit"><i class="bi bi-search"></i></button>
  </form>
  <table class="table table-sm table-bordered text-center m-0">
    <tbody>
      <!-- <tr>
        <th class="table-light p-0">ip</th>
        <td>{{response?.data?.ip}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">type</th>
        <td>{{response?.data?.type}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">continent_code</th>
        <td>{{response?.data?.continent_code}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">continent_name</th>
        <td>{{response?.data?.continent_name}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">country_code</th>
        <td>{{response?.data?.country_code}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">country_name</th>
        <td>{{response?.data?.country_name}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">region_code</th>
        <td>{{response?.data?.region_code}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">region_name</th>
        <td>{{response?.data?.region_name}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">city</th>
        <td>{{response?.data?.city}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">zip</th>
        <td>{{response?.data?.zip}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">latitude</th>
        <td>{{response?.data?.latitude}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">longitude</th>
        <td>{{response?.data?.longitude}}</td>
      </tr> -->
      <tr>
        <th class="table-light p-0">query</th>
        <td>{{response?.data?.query}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">status</th>
        <td>{{response?.data?.status}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">country</th>
        <td>{{response?.data?.country}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">countryCode</th>
        <td>{{response?.data?.countryCode}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">region</th>
        <td>{{response?.data?.region}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">regionName</th>
        <td>{{response?.data?.regionName}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">city</th>
        <td>{{response?.data?.city}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">zip</th>
        <td>{{response?.data?.zip}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">lat</th>
        <td>{{response?.data?.lat}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">lon</th>
        <td>{{response?.data?.lon}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">timezone</th>
        <td>{{response?.data?.timezone}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">isp</th>
        <td>{{response?.data?.isp}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">org</th>
        <td>{{response?.data?.org}}</td>
      </tr>
      <tr>
        <th class="table-light p-0">as</th>
        <td>{{response?.data?.as}}</td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped>
th {
  width: 40%;
  font-weight: normal;
}
td {
  text-align: left;
}
</style>
